import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Stage } from 'src/app/templates/models/stage.interface';
import { SchoolClass } from 'src/app/templates/models/schoolClass.interface';
import { Section } from 'src/app/templates/models/section.interface';
import { StagesQuery } from 'src/app/_models/system-setting/academics-manage/stages-query.interface';
import { Observable, forkJoin } from 'rxjs';
import { AttendanceSettingsMethod } from 'src/app/_models/academic/attendance/attendance-settings.interface';
import 'rxjs/add/observable/of';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {
  private url: string;
  private allClassesUrl: string;
  private sectionsByClassIdUrl: string;
  private stageAndClassUrl: string;

  classId: number;
  sectionId: number;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}`;
    this.allClassesUrl = `${this.url}Classes/GetAll`;
    this.sectionsByClassIdUrl = `${this.url}Sections/GetSectionsByClassId/`;
    this.stageAndClassUrl = `${this.url}Classes/GetStagesWithClass`;
  }

  clickedClassId: number = 0;

  getAllClasses() {
    return this.http.get(`${this.allClassesUrl}`);
  }

  getSectionsByClassId(classId: number) {
    return this.http.get(`${this.sectionsByClassIdUrl}${classId}`);
  }

  getStagesAndClasses(isForAddNewOverallSetting:boolean = false,overallScoreSettingId:number = null, parentSubjectId:any = null, isGpaOverall:boolean = false  ) {
    if(overallScoreSettingId)
    {
      return this.http.get(`${this.stageAndClassUrl}?isForAddNewOverallSetting=${isForAddNewOverallSetting}&overallScoreSettingId=${overallScoreSettingId}&isGpaOverall=${isGpaOverall}`);
    }
    else if(parentSubjectId)
    {
      return this.http.get(`${this.stageAndClassUrl}?isForAddNewOverallSetting=${isForAddNewOverallSetting}&parentSubjectId=${parentSubjectId}&isGpaOverall=${isGpaOverall}`);
    }
    else 
    {
      return this.http.get(`${this.stageAndClassUrl}?isForAddNewOverallSetting=${isForAddNewOverallSetting}&isGpaOverall=${isGpaOverall}`);
    }

  }

  // NEW

  getAllDefaultStages() {
    return this.http.get(`${this.url}Stages/DefaultStages`);
  }

  createDepartment(obj) {
    return this.http.post(`${this.url}Departments/Add`, obj);
  }

  getData(filter: StagesQuery) {
    if (filter.isFirstLoad) return this.getDefaults();
    else return this.getSchoolData(filter);
  }

  private getDefaults() {
    return forkJoin(this.http.get(`${this.url}Stages/DefaultStages`), this.http.get(`${this.url}Classes/DefaultClasses`));
  }

  private getSchoolData(filter: StagesQuery) {
    return forkJoin(
      this.http.get(`${this.url}Stages/GetAll`),
      this.http.get(`${this.url}Classes/GetAll`)
    );
  }

  checkIfFistLoad(filter: StagesQuery) {
    return this.http.get(`${this.url}Stages/IsThisFirstLoad`);
  }

  getAllAcademicYear(filter: StagesQuery): Observable<any[]> {
    return Observable.of([
      { id: 1, name: '2015-2016', thereIsPeriods: false, isActive: false },
      { id: 2, name: '2016-2017', thereIsPeriods: false, isActive: false },
      { id: 3, name: '2017-2018', thereIsPeriods: false, isActive: false }
    ]);
  }

  addFistLoadItems(obj: any) {
    return this.http.post(`${this.url}Stages/AddStructure`, obj);
  }

  addNewStage(stage: Stage) {
    return this.http.post(`${this.url}Stages/Add`, stage);
  }

  updateStage(stage: Stage) {
    return this.http.put(`${this.url}Stages/Update`, stage);
  }

  DeleteStage(stageId: number) {
    return this.http.delete(`${this.url}Stages/Delete/${stageId}`);
  }

  addNewClass(scoolClass: SchoolClass) {
    return this.http.post(`${this.url}Classes/Add`, scoolClass);
  }

  updateClass(schoolClass: SchoolClass) {
    return this.http.put(`${this.url}Classes/Update`, schoolClass);
  }

  UpdateClassesAttendanceMethod(schoolClass: AttendanceSettingsMethod[]) {
    return this.http.put(`${this.url}Classes/UpdateAttendanceMethod`, schoolClass);
  }

  deleteClass(classId: number) {
    return this.http.delete(`${this.url}Classes/Delete/${classId}`);
  }

  getclassSections(classId: number) {
    return this.http.get(`${this.url}Sections/GetSectionsByClassId/${classId}`);
  }

  updateSection(section: Section) {
    return this.http.put(`${this.url}Sections/Update`, section);
  }

  addSection(section: Section) {
    return this.http.post(`${this.url}Sections/Add`, section);
  }

  deleteSection(sectionId: number) {
    return this.http.delete(`${this.url}Sections/Delete/${sectionId}`);
  }

  toggleStages(academicYear) {
    // return this.http.put(`${this.url}AcademicYear/UpdateAcademicYearIsStageEnabled`, academicYear);
    return this.http.put(`${this.url}Stages/ToggleIsStageEnabled`, null);
  }
  GetClassSectionSubject(autocomplete: string) {
    return this.http.get(`${this.url}Classes/GetClassSectionSubject/${autocomplete}`);
  }
  GetClassSections(autocomplete: string) {
    return this.http.get(`${this.url}Sections/GetClassSections/${autocomplete}`);
  }
  GetSectionById(sectionId: number) {
    return this.http.get(`${this.url}Sections/GetSectionById/${sectionId}`);
  }
  updateAttendanceMethods(attendanceSettings: AttendanceSettingsMethod[]) {
    return this.http.put(`${this.url}Classes/UpdateAttendanceMethod`, attendanceSettings);
  }
  getClassesByAttendanceMethod(attendanceMethod: number) {
    return this.http.get(`${this.url}Classes/GetStagesWithClass/${attendanceMethod}`);
  }
  GetAllClassesByFilter(schoolId : number , educationalProgramId : number , academicYearId : number){
    return this.http.get(`${this.url}Classes/GetAllClassesByFilter/${schoolId}/${educationalProgramId}/${academicYearId}`)
  }
  getAllGlobalClasses()
  {
    return this.http.get(`${this.url}Classes/GetAllGlobalStagesWithClasses`)
  }
  GetAllGlobalStagesWithClassesForSchool()
  {
    return this.http.get(`${this.url}Classes/GetAllGlobalStagesWithClassesForSchool`)
  }

  getClassHighLightCount(classId:number)
  {
    return this.http.get(`${this.url}Classes/GetClassHighLightCount?classId=${classId}`);
  }

  getSchoolGlobalClasses(schoolId:number = null, educationalProgramId: number = null)
  {
    var qString = "?";

    if(schoolId)
      qString +=`&schoolId=${schoolId}`;

    if (educationalProgramId)
      qString +=`&educationalProgramId=${educationalProgramId}`;
    
    return this.http.get(`${this.url}Classes/GetSchoolGlobalClasses${qString}`);
  }

  addOrUpdateGlobalSchoolClass(schoolGlobalClasses:any)
  {
    return this.http.post(`${this.url}Classes/AddOrUpdateGlobalSchoolClass`, schoolGlobalClasses);
  }

  CreateOrUpdateClassroomEducator(data) {
    return this.http.post(`${this.url}Sections/createOrUpdateClassroomEducator`,data);
  }
}
